export default __webpack_public_path__ + "static/media/Wavy_Tech-21_Single-11.ce2d2016.jpg";